/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  MetaMcpDiscoveryFunnel,
  MetaMcpDiscoveryFunnel$inboundSchema,
} from "./metamcpdiscoveryfunnel.js";
import {
  MetaMcpMemberUsage,
  MetaMcpMemberUsage$inboundSchema,
} from "./metamcpmemberusage.js";

/**
 * Discovery funnel plus per-member execution breakdown for one gateway (meta MCP server). Zero counts mean no rows were observed in the window within telemetry retention — they do not distinguish an idle gateway from traffic outside the window or the 90-day retention; telemetry-disabled organizations get a not-found error instead of zeros.
 */
export type GetMetaMcpServerUsageResult = {
  /**
   * Counts of each gateway drill-down stage in the window. Discovery stages come from meta_discovery events; executions from gateway-attributed tool calls.
   */
  funnel: MetaMcpDiscoveryFunnel;
  /**
   * Per-member execution breakdown, most active first
   */
  members: Array<MetaMcpMemberUsage>;
};

/** @internal */
export const GetMetaMcpServerUsageResult$inboundSchema: z.ZodMiniType<
  GetMetaMcpServerUsageResult,
  unknown
> = z.object({
  funnel: MetaMcpDiscoveryFunnel$inboundSchema,
  members: z.array(MetaMcpMemberUsage$inboundSchema),
});

export function getMetaMcpServerUsageResultFromJSON(
  jsonString: string,
): SafeParseResult<GetMetaMcpServerUsageResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetMetaMcpServerUsageResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetMetaMcpServerUsageResult' from JSON`,
  );
}
